import {
  CapaRfqPurchaseOrderTransferTermsType,
  CreatePurchaseOrderInput
} from '@generated/graphql';
import { PurchaseOrderBaseData } from '../useBaseData';
import { PaymentInput } from '../Payment/Method';

interface ConvertTypeToCreatePurchaseOrderInputArguments {
  data: CreatePurchaseOrderInput & PaymentInput;
  basedData?: PurchaseOrderBaseData;
}

const convertTypeToCreatePurchaseOrderInput: (
  args: ConvertTypeToCreatePurchaseOrderInputArguments
) => CreatePurchaseOrderInput = ({ data, basedData }) => {
  if (!basedData) {
    throw new Error('견적서 데이터를 불러오지 못했습니다. 다시 시도해주세요.');
  }
  const { shipAddress, shipDate, shipDetailAddress } = data;
  const { quotationId, managerName } = basedData;
  const isNoTransfer =
    data?.transferTerms ===
    ('NO_TRANSFER' as CapaRfqPurchaseOrderTransferTermsType);

  return {
    quotationId,
    managerName,
    shipDate,
    shipAddress,
    shipDetailAddress,
    transferTerms: isNoTransfer ? undefined : data?.transferTerms,
    transferStorage: data?.transferStorage
      ? Number(data?.transferStorage)
      : undefined
  } as CreatePurchaseOrderInput;
};

export { convertTypeToCreatePurchaseOrderInput };
